import { render, staticRenderFns } from "./ArticleFormModal.vue?vue&type=template&id=5b83dd9c&scoped=true"
import script from "./ArticleFormModal.vue?vue&type=script&lang=js"
export * from "./ArticleFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b83dd9c",
  null
  
)

export default component.exports